import { submitForm } from './submit-form';
import { navigateToCheckout, } from './navigate-to-checkout';
export const FORM_ASYNC_ACTIONS = {
    submitForm,
    navigateToCheckout,
};
//# sourceMappingURL=index.js.map